import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHead } from "./Reveal";

const faqs = [
  ["Wann sollten wir mit der Modernisierung beginnen?", "Idealerweise ein bis drei Jahre vor dem geplanten Verkauf. So wirken die Maßnahmen schon im Alltag und sind bei der Due Diligence sauber dokumentiert."],
  ["Lohnt sich die Investition kurz vor dem Verkauf?", "Wir priorisieren nur Maßnahmen, die Risiken für Käufer senken oder den Betrieb sichtbar verbessern. In der Analyse zeigen wir, wo sich Aufwand lohnt – und wo nicht."],
  ["Bleibt unser Verkaufsvorhaben vertraulich?", "Ja. Auf Wunsch arbeiten wir unter Verschwiegenheitsvereinbarung und kommunizieren das Projekt intern als Modernisierung."],
  ["Arbeiten Sie mit unseren Beratern zusammen?", "Gern. Wir stimmen uns mit M&A-Beratern, Steuerberatern und Banken ab und liefern die Unterlagen, die sie brauchen."],
  ["Für welche Unternehmen ist Aufbruchwerk geeignet?", "Für inhabergeführte Unternehmen im deutschen Mittelstand, die an die nächste Generation übergeben oder extern verkauft werden sollen."],
];

export const Faq = () => (
  <section id="faq" data-testid="faq-section" className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-40">
    <SectionHead id="faq" eyebrow="05 — Fragen" title={["Was Inhaber", <span key="i" className="italic text-[var(--clay)]">uns fragen.</span>]} />
    <Reveal className="mt-14 lg:ml-[33.333%]">
      <Accordion type="single" collapsible data-testid="faq-accordion">
        {faqs.map(([q, a], i) => (
          <AccordionItem key={q} value={`f${i}`} className="border-[var(--line)]" data-testid={`faq-item-${i + 1}`}>
            <AccordionTrigger data-testid={`faq-trigger-${i + 1}`} className="font-serif-d py-7 text-left text-2xl font-normal hover:no-underline sm:text-3xl [&>svg]:text-[var(--clay)]">{q}</AccordionTrigger>
            <AccordionContent className="max-w-2xl pb-7 text-base leading-relaxed text-[var(--ink-2)]">{a}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </Reveal>
  </section>
);
